export default __webpack_public_path__ + "static/media/Heatmap_DXC_Logo.eb930997.png";